/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-03-02 10:44:44
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-02 10:50:34
 */
export const publicUrlConfig = {
  mobile: {
    bgImg: require('@/static/assets/ui/mobile/bg.jpg'),
    titleImg: require('@/static/assets/ui/mobile/title.png')
  },
  pc: {
    bgImg: require('@/static/assets/ui/pc/bg.jpg'),
    titleImg: require('@/static/assets/ui/pc/title.png')
  }
}
